import { css } from '@emotion/react';
import { Box } from '@spark-web/box';
import { Heading } from '@spark-web/heading';
import { ContentDialog } from '@spark-web/modal-dialog';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextLinkButton } from '@spark-web/text-link';
import { useTheme } from '@spark-web/theme';
import { useState } from 'react';

import { CHANNEL_REQUIREMENTS, PARTNER_TO_CHANNEL } from '~/constants';
import { useModal } from '~/hooks/useModal';
import { useLeadContext } from '~/provider/LeadProvider';

import { BrighteLogo } from '../common/brighte-logo';

import { NeedHelpContent } from './need-help-content';

export const NeedHelp = () => {
  const { lead: customer } = useLeadContext();
  const theme = useTheme();

  const [dialog, setDialog] = useState<'CALLBACK' | 'FORM' | null>(null);
  const { ref, onCloseAutoFocus } = useModal('need-help');

  const onLearnMore = () => {
    if (customer?.contact?.firstName) {
      setDialog('CALLBACK');
    } else {
      setDialog('FORM');
    }
  };

  const channel = customer?.partner ? PARTNER_TO_CHANNEL(customer.partner) : undefined;
  const supportDetails = channel ? CHANNEL_REQUIREMENTS[channel]?.supportDetails : undefined;

  return (
    <>
      <Box
        display="flex"
        border="fieldAccent"
        padding="large"
        paddingBottom="xxlarge"
        borderRadius="medium"
        borderWidth="large"
        background="neutral"
        css={css({
          [`@media (min-width: ${theme.breakpoint.tablet}px)`]: {
            gridColumn: 'span 2',
          },
        })}
      >
        <Stack gap="xlarge">
          <BrighteLogo />
          <Heading level="3" as="h2">
            Need help?
          </Heading>
          {supportDetails ? (
            supportDetails()
          ) : (
            <>
              <Text size="xsmall">
                Speak to an expert at Brighte to find the best solutions and vendors for your upgrades.
              </Text>
              <Text tone="info" size="xsmall">
                <TextLinkButton ref={ref} onClick={onLearnMore}>
                  Learn more
                </TextLinkButton>
              </Text>
            </>
          )}
        </Stack>
      </Box>
      <ContentDialog
        title="Need help?"
        showCloseButton
        isOpen={!!dialog}
        onToggle={() => setDialog(null)}
        onCloseAutoFocus={onCloseAutoFocus}
      >
        <NeedHelpContent dialog={dialog} onSuccess={() => setDialog(null)} />
      </ContentDialog>
    </>
  );
};
